// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + chunkId + "." + {"495": "962802bd5dc1a620","928": "25cd4dbd6fab9d7d",}[chunkId] + ".js"
}